import { render } from "./resetPasswordComponent.vue?vue&type=template&id=fbcfda66&scoped=true"
import script from "./resetPasswordComponent.vue?vue&type=script&lang=js"
export * from "./resetPasswordComponent.vue?vue&type=script&lang=js"

import "./resetPasswordComponent.vue?vue&type=style&index=0&id=fbcfda66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbcfda66"]])

export default __exports__